import { BrFilter } from '../../../../generated/product-service-graphql';
import { BrLeafFilterValue, FilterOption } from '../types';

const mapFilterValues = (filter: BrFilter, value: BrLeafFilterValue): FilterOption => ({
  filterId: filter.id,
  filterValueId: value.id,
  filterValueLabel: value.label,
  filterValueInputValue: value.input.value,
});

export const brFiltersToFilterOptions = (brFilters: BrFilter[] = []): FilterOption[] => {
  return brFilters.flatMap((filter): FilterOption[] => {
    switch (filter.__typename) {
      case 'ColorFilter':
      case 'FabricFilter':
      case 'ListFilter':
        const filterValues = filter.values as BrLeafFilterValue[];
        return filterValues.map((value) => mapFilterValues(filter, value));
      case 'GroupedListFilter':
      case 'SizeFilter':
        return filter.groups.flatMap((group) => group.values.map((value) => mapFilterValues(filter, value)));
      default:
        return [];
    }
  });
};
